module.exports = __webpack_public_path__ + "static/media/rouge.2b040236.png";